import React from 'react';

import { Box } from '@mui/material';

const overlayStyles = {
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  backgroundColor: '#9f3a38',
  opacity: 0.05,
  pointerEvents: 'auto',
  zIndex: 2,
};

const noteStyles = {
  color: '#9f3a38',
  fontSize: '12px',
  background: 'rgba(159,58,56,0.05)',
  padding: '4px 8px 4px 8px',
  borderRadius: '4px',
  marginTop: '4px',
  marginBottom: '4px',
  zIndex: 3,
  position: 'relative',
  pointerEvents: 'auto',
};

function OhsFieldWithNoteOverlay({ children, note }: { children: React.ReactNode; note?: string }) {
  if (!note) return children;
  return (
    <Box sx={{ position: 'relative', width: '100%' }}>
      <Box sx={overlayStyles} />
      <Box sx={{ position: 'relative', zIndex: 1, pointerEvents: 'none' }}>{children}</Box>
      <Box sx={noteStyles}>
        <b>Note:</b> {note}
      </Box>
    </Box>
  );
}

OhsFieldWithNoteOverlay.defaultProps = {
  note: undefined,
};

export default OhsFieldWithNoteOverlay;
